import { JSX, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  loadInitialAuthenticationStateAsync,
  selectAuthInitializationStatus,
} from "../../features/authentication/authenticationSlice";

const InitializeAuth = ({ children }: { children: JSX.Element }) => {
  const initializationStatus = useAppSelector(selectAuthInitializationStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (initializationStatus === "not-initialized") {
      dispatch(loadInitialAuthenticationStateAsync());
    }
  }, [dispatch, initializationStatus]);

  if (initializationStatus === "initialized") {
    return children;
  }

  return <></>;
};
export default InitializeAuth;
